import { useCurrentUser } from 'hooks/useCurrentUser';
import { useCurrentCaseId } from 'hooks/useCurrentCase';
import { APP_VERSION } from 'config/constants';
import { DEPLOY_ENV } from 'config';
import { useMemo } from 'react';
import { WithApolloContext } from 'modules/Apollo/types';

export const useSessionContext = ({
  context,
}: WithApolloContext): {
  email: Nullable<string>;
  caseId: Nullable<string>;
  version: string;
  env: Nullable<string>;
} => {
  const { data } = useCurrentUser({ context });
  const email = data?.me?.email;
  const caseId = useCurrentCaseId();

  return useMemo(() => ({ email, caseId, version: APP_VERSION, env: DEPLOY_ENV }), [email, caseId]);
};
